<template>
  <div class="row">
    <div class="col-md-9">
      <div class="card">
        <div class="card-header cursor-pointer">
          <div
            class="card-title m-0 d-flex justify-content-between align-items-center"
          >
            <h3 class="fw-bold m-0">{{ $t('account.profileDetails') }}</h3>

            <button
              @click="changeComponent('Settings')"
              class="btn btn-primary rounded-sm"
            >
              {{ $t('global.update') }}
            </button>
            <!-- <a href="https://accounts.plusclouds.com/general"
               target="_blank"
               class="btn btn-primary rounded-sm">{{$t('global.update')}}</a> -->
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <label class="col-md-4 text-muted mb-8">{{
              $t('account.fullName')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{ user.fullname }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.about')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{ user.about ? user.about : '-' }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.gender')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{ user.gender ? $t('gender.' + user.gender) : '-' }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.birthday')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{
                user.birthday
                  ? $customFunctions.setMomentWithFormat(user.birthday, 'L')
                  : '-'
              }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('global.email')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{ user.email ? user.email : '-' }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.phone')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{
                user.cell_phone
                  ? '+' + user.cell_phone_code + ' ' + user.cell_phone
                  : '-'
              }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.country')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{ user.country_name ? user.country_name : '-' }}</span>
            </div>

            <label class="col-md-4 text-muted mb-8">{{
              $t('account.accountType')
            }}</label>
            <div class="col-lg-8 font-weight-bold">
              <span>{{
                user.masterAccount &&
                user.masterAccount.data &&
                user.masterAccount.data.account_type
                  ? $t(
                      'accountType.' + user.masterAccount.data.account_type.name
                    )
                  : '-'
              }}</span>
            </div>

            <label
              class="col-md-4 text-muted mb-8"
              v-if="user.roles && user.roles.data && user.roles.data.length > 0"
              >{{ $t('account.roles') }}</label
            >
            <div class="col-lg-8 font-weight-bold">
              <label
                v-for="role in user.roles.data"
                :key="role.id"
                class="badge badge-dark mr-2"
              >
                {{ role.label }}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3">
      <Agent :user="user" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Overview',
  props: {
    user: Array | String,
  },
  methods: {
    changeComponent(newComponent) {
      this.$emit('changeComponent', newComponent)
    },
  },
  components: {
    Agent: () => import('@/components/account/Agent'),
  },
}
</script>
